import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'sume-card-header',
    templateUrl: './card-header.component.html',
    styleUrls: ['./card-header.component.scss'],
})
export class CardHeaderComponent {
    @Input() title = '';
    @Input() tooltipMessage = '';
    @Input() goBackLink: string | [] = '';
    @Input() fragment: string;
    @Input() linkQueryParams!: { [key: string]: string };
    @Input() relativeTo = this.route;

    constructor(private route: ActivatedRoute) {}
}
